import { Tooltip } from "@chakra-ui/react";
import { DatePicker } from "components/Atomos/DatePicker";
import React, { useEffect, useState } from "react";

interface Props {
    label?: string;
    onChange: (s: Date | null, e: Date | null) => void;
    cleanupExternal?: boolean;
}

const DatePeriodFilter: React.FC<Props> = ({
    label,
    onChange,
    cleanupExternal
}) => {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const onChangeValue = (dates: (Date | null)[]) => {
        const [start, end] = dates;

        setStartDate(start);
        setEndDate(end);
    };

    useEffect(() => {
        onChange(startDate, endDate);
    }, [endDate]);

    useEffect(() => {
        setStartDate(null);
        setEndDate(null);
    }, [cleanupExternal]);

    return (
        <Tooltip label={label ?? "Selecione o período"} placement="top">
            <div>
                <DatePicker
                    onChange={onChangeValue}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange={true}
                    isClearable
                    label="Selecione o Período"
                />
            </div>
        </Tooltip>
    );
};

export default DatePeriodFilter;